import { isNavigatingWithinMicroAppRoutes } from './micro-app-router-fix.utils';

// HACK ALERT! This module's sole purpose is to let `ui-router` yield routing
// inside of micro apps.
//
// Without this fix, ui-router will reload the micro app state whenever the
// `history` API "popstate" event is triggered (basically, clicking the
// browser's back/forward buttons).
export default angular
  .module('app.steps.microapp-router-fix', [])
  .run(($rootScope, appShell) => {
    let hasEnteredInitialState = false;

    // Make sure we don't prevent the initial state from loading,
    // else we'd be stuck with a blank page.
    $rootScope.$on(
      '$stateChangeSuccess',
      () => (hasEnteredInitialState = true)
    );

    $rootScope.$on('$locationChangeSuccess', (event, newUrl, oldUrl) => {
      if (
        hasEnteredInitialState &&
        (isNavigatingWithinMicroAppRoutes(oldUrl, newUrl) ||
          appShell.isAnAppShellRoute(newUrl))
      ) {
        // Keeps `$stateChangeStart` from being emitted by `ui-router`.
        event.preventDefault();
      }
    });
  });
